<template>
  <div id="roleTemplateDetails">

    <div class="section-content">
    
      <template v-if="selected">
      
        <div class="vo-card">
        
          <div class="vo-header">
            Role Template Details
          </div>
          <div class="vo-content">
           
            <div class="vo-s-list">
              <div class="name">Title</div>
              <div class="value">{{ selected.title }}</div>
            </div>

            <div class="vo-s-list" v-if="!selected.isCustom">
              <div class="name">Base Role</div>
              <div class="value">This is a base role and cannot be modified.</div>
            </div>

          </div>
          <div class="vo-footer" v-if="selected.isCustom">
            <v-btn flat class="vo-button" @click="routeAddQueries({ dialog: 'role-template-manage', dialogAction: 'edit' })">
              <v-icon>mdi-pencil</v-icon>
              <span>Edit</span>
            </v-btn>
            <v-btn flat class="vo-button red" @click="deleteRoleTemplateDialog">
              <v-icon>mdi-delete</v-icon>
              <span>Delete</span>
            </v-btn>
          </div>
        </div>

      </template>

      <template v-else>
        <vo-empty-state text="SELECT A ROLE TEMPLATE"></vo-empty-state>
      </template>
    </div>

    <vo-details-header></vo-details-header>

  </div>
</template>

<script>

  import DetailsMixin from '../mixins/detailsMixin.js';

  export default {
  
    mixins: [DetailsMixin],
   
    data () {
      return {

      }
    },

    methods: {

      deleteRoleTemplateDialog () {

        Dialog.showDialog({
          title: 'Delete Role Template',
          body: 'Are you sure you want to delete this role template?',
          confirm: {
            title: 'Delete',
            action: () => {
              
              return this.$store.dispatch('deleteRoleTemplate', {
                role: this.page.selected
              })
              .then(data => {
                this.page.list.removeItem(this.page.selected);
                this.page.selected = false;

                // Reinit Filters to reflect changes
                window.AppData.initFilters();

                this.routeRemoveQuery('details');

                Toast.show('Role Template deleted.', 'success');
                return Promise.resolve();
              })
              .catch(e => {
                console.log(e);
                Toast.showError(e);
                return Promise.reject();
              });
            
            }
          }
        });
      },

      loadRoleTemplate () {
        this.selectFromDetails(this.page, 'loadRoleTemplate', {
          role: this.$route.query.details
        });
      }

    },

    computed : {

      selected () {
        return this.$store.getters.roleTemplate(this.page.selected);
      }

    },

    watch: {
      
      '$route.query.details' () {
        this.loadRoleTemplate();
      }

    },

    created () {
      this.loadRoleTemplate();
    }

  };

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #roleTemplateDetails {
    
    @include fontPrimary400();

    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
      
    .section-content {
      @include scrollContainer();
      top: 48px;

      background: $lightGreen; 
      padding: 16px;
      box-sizing: border-box;
    }
  
  }

</style>



// WEBPACK FOOTER //
// src/components/RoleTemplateDetails.vue